export class TeamEncryptedData {
    version: number;
    color: string;
    description: string;
    name: string;
    defaultRole: number;
    defaultTeam: boolean = false;
}